import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

const now = new Date();
@Component({
  selector: 'app-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.css']
})
export class AwardsComponent implements OnInit {
  Isotope : any;
  Awards: any = []; 
  responseAPIstatus: boolean = true;
  lowYear: number;
  highYear: number;
  constructor(@Inject(DOCUMENT) private document: Document, private homepageService: HomepageService ){}
  ngOnInit() {
    this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
    this.getAwards();
  }

  //To get awards lists.
  getAwards() {
    return this.homepageService.getAwards().subscribe(( data: any) => {
      this.Awards = data.data;
      if(this.Awards.recentYears){
        this.highYear = this.Awards.recentYears[0];
        var high =  parseInt(this.Awards.recentYears.length) -1;
        this.lowYear = this.Awards.recentYears[high];
      }
      this.responseAPIstatus = false;
      setTimeout(function(){
        var grid = document.querySelector('#grid');
        var iso = new this.Isotope( grid, {
          itemSelector: '.grid-item',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
      },100);
    });
  }
}
